import type { PersistenceCollection } from '@tadpoles/persistence'
import type { IdentityPersistenceCollectionDefinition } from '@tadpoles/persistence'
import { Type, type Static } from 'typebox'

export type CachedAttachmentMetadata = Static<typeof CachedAttachmentMetadata>
export const CachedAttachmentMetadata = Type.Object({
    url: Type.String({ minLength: 1, maxLength: 8_192 }),
    cachedAt: Type.Integer({ minimum: 0 }),
    lastValidatedAt: Type.Integer({ minimum: 0 }),
    size: Type.Optional(Type.Integer({ minimum: 0 }))
})

export type FamilyAttachmentMetadataStore = PersistenceCollection<CachedAttachmentMetadata, 'url'>

export const AttachmentMetadataCollectionDefinition: IdentityPersistenceCollectionDefinition<
    typeof CachedAttachmentMetadata,
    'url'
> = {
    kind: 'attachment-metadata',
    scope: 'user',
    primaryKey: 'url',
    modelSchema: CachedAttachmentMetadata
}
